import { Injectable, inject } from '@angular/core';
import { ProjectModel } from '../../../../../../../core/models/project/project.model';
import { TimeBlockWithTask } from '../../../../../../../shared/data-types/shared-time-block-types';
import { ExpenditureOptions } from '../../../../../../../core/constants-repository/project-calculation.constants';
import { ProjectMonetaryCalculationService } from '../../../../project-progress/services/project-monetary-calculation.service';
import { Interval } from 'date-fns';
import { TimeBlockFee } from '../../../edit-project.types';
import { DateTimeHelper } from '../../../../../../../features/calendar/util/date-time-helper';
import { DefaultDateFormat } from '../../../../../../../shared/localization/formats';
import { BudgetCalculationService } from './budget-calculation.service';
import { TimeBlockDurationCalculationService } from '../../../../../../../features/calendar/components/time-block/calculation/duration/time-block-duration-calculation.service';
import { TimeBlockFeeCalculationService } from '../../../../project-progress/services/time-block-fee-calculation.service';

@Injectable({
  providedIn: 'root',
})
export class ExpenditureCalculationService {
  private readonly projectMonetaryCalculationService = inject(ProjectMonetaryCalculationService);
  private readonly timeBlockFeeCalculationService = inject(TimeBlockFeeCalculationService);
  private readonly timeBlockDurationCalculationService = inject(
    TimeBlockDurationCalculationService,
  );

  public calcFeeSumForTimeBlock(
    project: ProjectModel,
    timeBlocksWithTask: readonly TimeBlockWithTask[],
  ): number | null {
    if (project.expenditureType === ExpenditureOptions.ExpendituresInHours) {
      return null;
    }

    const timeBlockFees = this.timeBlockFeeCalculationService.timeBlockFeesOfProject(
      project,
      timeBlocksWithTask,
      true,
    );

    return this.projectMonetaryCalculationService.calculateFeeSum(timeBlockFees);
  }

  public calcExpenditurePerDay(
    project: ProjectModel,
    timeBlockWithTasks: readonly TimeBlockWithTask[],
    range: Interval = { start: null, end: null },
  ): Map<string, number> {
    const timeBlockFees = this.timeBlockFeeCalculationService.timeBlockFeesOfProject(
      project,
      timeBlockWithTasks,
      true,
      range,
    );

    const amount =
      BudgetCalculationService.getFeeUnit(project) === 'monetary'
        ? (fee: TimeBlockFee) => {
            return this.projectMonetaryCalculationService.calculateFeeSum([fee]);
          }
        : (fee: TimeBlockFee) => {
            return this.timeBlockDurationCalculationService.calculateTimeBlockTimeSum(
              [fee.timeBlockWithTask.timeBlock],
              true,
            );
          };

    const timeBlockFeeMap = new Map<string, number>();

    timeBlockFees.forEach((fee) => {
      const timeBlock = fee.timeBlockWithTask.timeBlock;
      const dateKey = DateTimeHelper.format(timeBlock.timeBlockModel.start, DefaultDateFormat);
      let sum = amount(fee);
      sum += timeBlockFeeMap.get(dateKey) ?? 0;
      timeBlockFeeMap.set(dateKey, sum);
    });
    return timeBlockFeeMap;
  }
}
